export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8854.49e0cd74.jpg";